module.exports = __webpack_public_path__ + "img/treatments-4.45e3c472.png";